import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";
import { useEventEarlyBird, formatEarlyBirdCountdown } from "@/hooks/useEventEarlyBird";

type Props = {
  eventId: string;
  variant?: "pill" | "banner";
  showCountdown?: boolean;
};

const EarlyBirdBadge = ({ eventId, variant = "pill", showCountdown = true }: Props) => {
  const { data } = useEventEarlyBird(eventId);
  if (!data?.active) return null;

  const label = `Early bird -${Math.round(data.discount_percent || 0)}%`;
  const countdown = formatEarlyBirdCountdown(data.ends_at);

  if (variant === "banner") {
    return (
      <div className="rounded-lg border border-accent/40 bg-accent/10 p-3 mb-3 flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-accent-foreground shrink-0" />
        <div className="text-sm">
          <span className="font-semibold text-accent-foreground">{label}</span>
          {showCountdown && <span className="text-muted-foreground"> · {countdown}</span>}
        </div>
      </div>
    );
  }

  return (
    <Badge variant="secondary" className="flex items-center gap-1 w-fit bg-warning/15 text-warning-foreground border border-warning/40">
      <Sparkles className="h-3 w-3" />
      {label}{showCountdown ? ` · ${countdown}` : ""}
    </Badge>
  );
};

export default EarlyBirdBadge;
